// extracted by mini-css-extract-plugin
export default {"main":"categoriesCharts_main__3X9f6","charts":"categoriesCharts_charts__GfA7K","info":"categoriesCharts_info__ESktL"};